"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpectedValueDescriptor = exports.getArrayExpectedValueType = void 0;
const expected_value_types_1 = require("./expected-value-types");
const expected_values_options_1 = require("./expected-values-options");
const getArrayExpectedValueType = (childrenTypeArray) => {
    const containsArray = childrenTypeArray.some((type) => type === "array");
    const containsObject = childrenTypeArray.some((type) => type === "object");
    const dataTypes = childrenTypeArray.filter((type) => type !== "array" && type !== "object" && expected_values_options_1.dataTypeOptions.includes(type));
    const containsDataType = !!dataTypes.length;
    if (containsArray && !containsObject && !containsDataType) {
        return expected_value_types_1.ArrayType.arrayArray;
    }
    else if (containsObject && !containsArray && !containsDataType) {
        return expected_value_types_1.ArrayType.propertyObjectArray;
    }
    else if (containsDataType && !containsArray && !containsObject) {
        const containsText = dataTypes.some((type) => type === expected_values_options_1.textDataTypeId);
        const containsBoolean = dataTypes.some((type) => type === expected_values_options_1.booleanDataTypeId);
        const containsNumber = dataTypes.some((type) => type === expected_values_options_1.numberDataTypeId);
        if (containsText && !containsBoolean && !containsNumber) {
            return expected_value_types_1.ArrayType.textArray;
        }
        else if (containsBoolean && !containsText && !containsNumber) {
            return expected_value_types_1.ArrayType.booleanArray;
        }
        else if (containsNumber && !containsText && !containsBoolean) {
            return expected_value_types_1.ArrayType.numberArray;
        }
    }
    return expected_value_types_1.ArrayType.mixedArray;
};
exports.getArrayExpectedValueType = getArrayExpectedValueType;
const getExpectedValueDescriptor = (id, flattenedExpectedValues) => {
    const data = flattenedExpectedValues[id]?.data;
    if (!data) {
        throw new Error("Cannot get expected value descriptor, data missing");
    }
    switch (data.typeId) {
        case "array":
            return {
                typeId: "array",
                arrayType: (0, exports.getArrayExpectedValueType)(Object.values(flattenedExpectedValues)
                    .filter(({ parentId }) => parentId === id)
                    .map(({ data: childData }) => {
                    if (typeof childData !== "object") {
                        throw new Error("Expected value doesn't have data");
                    }
                    return childData.typeId;
                })),
                id,
            };
        case "object":
            return {
                typeId: "object",
                id,
            };
        default:
            return data.typeId;
    }
};
exports.getExpectedValueDescriptor = getExpectedValueDescriptor;
